import { queryOptions } from "@tanstack/react-query";
import { backendFetch } from "@softmax/observatory-client/transport";
import type { FlagsResponse } from "@softmax/observatory-client/types";

export const siteFlagsQueryOptions = () =>
  queryOptions({
    queryKey: ["flags", "me", { elevatedPrivileges: false }],
    queryFn: ({ signal }) =>
      backendFetch<FlagsResponse>("", "/api/site-flags", {
        signal: signal,
      }),
    staleTime: 30_000,
  });
